var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.324 11.3119C42.7971 11.9872 41.1779 12.4308 39.52 12.6279C41.2675 11.5827 42.5754 9.93788 43.2 7.99985C41.56 8.97585 39.762 9.65985 37.888 10.0299C36.6292 8.68301 34.9607 7.78978 33.1419 7.48902C31.3231 7.18827 29.4559 7.49684 27.8305 8.36676C26.2052 9.23668 24.9128 10.6192 24.1542 12.2994C23.3957 13.9797 23.2135 15.8634 23.636 17.6579C20.3102 17.4912 17.0567 16.6269 14.0866 15.1212C11.1165 13.6155 8.49625 11.5019 6.396 8.91785C5.65258 10.1948 5.26191 11.6463 5.264 13.1239C5.264 16.0239 6.74 18.5859 8.984 20.0859C7.65602 20.044 6.35726 19.6854 5.196 19.0399V19.1439C5.1964 21.0753 5.86474 22.9471 7.08769 24.442C8.31065 25.9369 10.013 26.9628 11.906 27.3459C10.6732 27.6799 9.38061 27.7292 8.126 27.4899C8.65973 29.1523 9.70001 30.6063 11.1012 31.6481C12.5024 32.6899 14.1943 33.2674 15.94 33.2999C14.205 34.6625 12.2184 35.6698 10.0938 36.2642C7.96917 36.8586 5.74825 37.0284 3.558 36.7639C7.38139 39.2227 11.8322 40.5281 16.378 40.5238C31.764 40.5238 40.178 27.7779 40.178 16.7239C40.178 16.3639 40.168 15.9999 40.152 15.6439C41.7897 14.4602 43.2032 12.9939 44.326 11.3139L44.324 11.3119Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.7c5f491aa845b6a2f1e8c0bd14997c9e.svg";
export { ForwardRef as ReactComponent };